<template>
  <div>
    <!-- BOC:[error] -->
    <AErrorV1 :api="api"></AErrorV1>
    <!-- EOC -->
    <!-- BOC:[form] -->
    <v-form ref="form" lazy-validation @submit.prevent="validate">
      <v-card>
        <v-card-title>Add Mission</v-card-title>
        <v-card-text>
          <div>
            <Syllabus
              class="pt-4"
              ref="syllabus"
              :callbackSelect="selectSyllabus"
              :callbackError="showError"
            />
          </div>

          <div v-if="syllabus && syllabus.key">
            <Chapter
              class="pt-4"
              ref="chapter"
              :syllabus="syllabus"
              :callbackSelect="selectChapter"
              :callbackError="showError"
              @input="form.chapterKey = $event"
            />
          </div>
          <div v-if="chapter && chapter.key">
            <Question
              class="pt-4"
              ref="question"
              :chapter="chapter"
              :callbackSelect="selectQuestion"
              :callbackError="showError"
              @input="form.questionKey = $event"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
          <v-btn color="primary" :loading="api.isLoading" @click="submit">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <!-- EOC -->
  </div>
</template>


<script>
import Syllabus from "@/components/Moderator/Mission/Syllabus";
import Chapter from "@/components/Moderator/Mission/Chapter";
import Question from "@/components/Moderator/Mission/Question";
export default {
  props: ["self", "role", "model", "url", "action", "callbackSuccess"],
  data: () => ({
    syllabus: {},
    chapter: {},
    question: null,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    form: {},
  }),

  components: {
    Syllabus,
    Chapter,
    Question,
  },
  created() {
    //BOC:[api]
    this.api.url = this.url;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.callbackSuccess(resp);
    };
    //EOC
  },
  methods: {
    showError(error) {
      this.api.isError = true;
      this.api.error = error;
    },
    selectSyllabus(item) {
      this.syllabus = item;
      var that = this;
      setTimeout(() => {
        that.$refs["chapter"].fetch();
      }, 100);
    },
    selectChapter(item) {
      this.chapter = item;
      this.form.chapterKey = item.key;
      var that = this;
      setTimeout(() => {
        that.$refs["question"].fetch();
      }, 100);
    },
    selectQuestion(item) {
      this.question = item;
      this.form.questionKey = item.key;
    },
    submit() {
      this.api.params = this.$_.clone(this.form);
      this.$api.fetch(this.api);
    },
  },
};
</script>
